import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { FinanciamientoApiService } from 'src/app/services/financiamiento-reusable.service';
import { MatAccordion } from '@angular/material/expansion';
import { MediaMatcher } from '@angular/cdk/layout';
import { Globals } from 'src/app/globals';
import { SupplyService } from 'src/app/services/supply.service';
import { VisorDocumentosComponent } from '../visor-documentos/visor-documentos.component';
import { MatDialog } from '@angular/material';

import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { DialogoConfirmacionComponent } from '../dialogo-confirmacion/dialogo-confirmacion.component';


@Component({
  selector: 'app-datos-solicitante',
  templateUrl: './datos-solicitante.component.html',
  styleUrls: ['./datos-solicitante.component.scss']
})

export class DatosSolicitanteComponent implements OnInit {
  panelOpenState = false;
  @ViewChild(MatAccordion) accordion: MatAccordion;

  tip_doc = '';

  thumbnail: any;

  dataSource: any[] = [];
  //dsBandeja: any[] = [];
  //dsTemporal: any[] = [];
  filesMap: Map<number, any> = new Map<number, any>();
  selected: any;
  //filesMapTemp: Map<number, any> = new Map<number, any>();
  sizeFile: number = 0;

  datoSolCorrecto: number = 1;

  limitFile_pdf: number;
  limitFile_jpg: number;
  bandejaId: number;
  estadoTramite: string;
  secuenciaSuministro: number;
  codigoOficina: number;

  existeBandeja: boolean = false;

  codigoValidacion: string;
  codigoValidacionWeb: string;
  correoTemporal: string;
  showSuministro = true;

  data: any;
  dataSolcitante: any;
  dataInput: any;
  nro_sumininstro: string;
  nombres: string;
  apellidos: string;
  paterno: string;
  materno: string;
  tipo_documento: string;
  desc_tipo_docu: string;
  nro_documento: string;
  parentesco: string;
  telefono: number;
  celular: number;
  correo: string;

  correoValiRemitente: string ="";
  correoValiAsunto: string ="";
  correoValiParrafo01: string ="";
  correoValiParrafo02: string ="";

    @BlockUI() blockUI: NgBlockUI;
    navigationSubscription;
    flagCodigovalidacion: boolean;
    mobileQuery: MediaQueryList;
    datos: FormGroup;

    toggle: boolean = true;
    flag: boolean = false;
    flag2: boolean = false;
    flag3: boolean = false;
    flag4: boolean = false;
    flagBoton: boolean = true;
    flagBotonFina: boolean = true;
    flagBotonDato: boolean = false;
    flagBotonDocs: boolean = false;
    flagEnableParent: boolean = false;
    flagEnviar: boolean = true;
    returnDialog: boolean = false;
    disabledActions: boolean = false;
    mailValido: boolean = true;
    botonIr: string;
    tiposDocumento = [
      {
        "tipo": "",
        "descripcion": "<<Seleccione>>"
      }
    ];
    parentescos = [
      {
        "cod": "",
        "descCod": "<<Seleccione>>"
      }
    ];

    private _mobileQueryListener: () => void;

    constructor( private sanitizer: DomSanitizer,
                 private supplyService: SupplyService,
                 private router: Router,
                 private toastr: ToastrService,
                 private financiamientoApiService: FinanciamientoApiService,
                 private globals: Globals,
                 changeDetectorRef: ChangeDetectorRef,
                 public dialog: MatDialog,
                 public media: MediaMatcher) {
      this.mobileQuery = media.matchMedia("(max-width: 600px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
      this.navigationSubscription = this.router.events.subscribe((e: any) => {
        if (e instanceof NavigationEnd && this.showSuministro === false) {
          this.showSuministro = true;
          this.ngOnInit();
        }
      });

      this.data = JSON.parse (localStorage.getItem ('data'));
      console.log("this.data",this.data);

      if (this.data) {
        this.nro_sumininstro = this.data.suministro;
        this.secuenciaSuministro = this.data.secuSuministro;
        this.codigoOficina = this.data.codOficina;
        this.nombres = this.data.nombres;
        this.apellidos = this.data.apellidos;
        this.paterno = this.data.paterno;
        this.materno = this.data.materno;
        this.tipo_documento = this.data.tipo_documento;
        this.desc_tipo_docu = this.data.desc_tipo_docu;
        this.nro_documento = this.data.numero_documento;
        this.parentesco = this.data.parentesco;
        this.telefono = this.data.telefono;
        this.celular = this.data.celular;
        this.correo = this.data.correo;
        //this.dataSolcitante = JSON.parse (localStorage.getItem ('dataSolicitante'));
        this.dataSolcitante = this.data;
        console.log("dataSolicitante",this.dataSolcitante);

      }

      console.log("existeBandeja",this.globals.existeBand);
      console.log("estadoTramite",this.globals.idBandejaGlob)


      if (this.dataSolcitante) {
        //this.bandejaId = this.dataSolcitante.idBandeja;
        this.bandejaId = this.globals.idBandejaGlob;

        if (this.secuenciaSuministro == null || this.secuenciaSuministro == undefined) {
          this.secuenciaSuministro = this.dataSolcitante.secuenciaSuministro;
        }

        if (this.codigoOficina == null || this.codigoOficina == undefined) {
          this.codigoOficina = this.dataSolcitante.codigoOficina;
        }

        if (this.nro_sumininstro == null || this.nro_sumininstro == undefined || this.nro_sumininstro == 'NaN') {
          this.nro_sumininstro = this.dataSolcitante.suministro;
        }

        if (this.parentesco == null || this.parentesco == undefined || this.parentesco == 'NaN') {
          this.parentesco = this.dataSolcitante.tipoSolicitante;
        }

        if (this.nombres == null || this.nombres == undefined || this.nombres == 'NaN') {
          this.nombres = this.dataSolcitante.nombresSolicitante;
        }

        if (this.apellidos == null || this.apellidos == undefined || this.apellidos == 'NaN') {
          this.apellidos = this.dataSolcitante.paternoSolicitante || ' ' || this.dataSolcitante.maternoSolicitante;
        }

        if (this.tipo_documento == null || this.tipo_documento == undefined || this.tipo_documento == 'NaN') {
          this.tipo_documento = this.dataSolcitante.tipoDocumento;
        }

        if (this.desc_tipo_docu == null || this.desc_tipo_docu == undefined || this.desc_tipo_docu == 'NaN') {
          this.desc_tipo_docu = this.getDescTipoDoc(this.tipo_documento);
        }

        if (this.nro_documento == null || this.nro_documento == undefined || this.nro_documento == 'NaN') {
          this.nro_documento = this.dataSolcitante.numDocumento;
        }

        if (this.telefono == null || this.telefono == undefined) {
          this.telefono = this.dataSolcitante.telefonoSolicitante;
        }

        if (this.celular == null || this.celular == undefined) {
          this.celular = this.dataSolcitante.celularSolicitante;
        }

        if (this.correo == null || this.correo == undefined || this.correo == 'NaN') {
          this.correo = this.dataSolcitante.correoSolicitante;
        }
        //DATOS DE LA BANDEJA SOLICITANTE QUE SE PUEDEN UTILIZAR
        //usuario, fechaActual, programa, fechaUltimoMovimiento, fechaAlta, numeroAcuerdo, fechaSolicitud,
        //numArchivo, deudaTotal, numCuota, montoCuota, numRecibo, estadoSolicitante, motivoEstadoSolicitante,
        //estadoTramite, tipoTramite, indicadorDescarga, indicadorCorreo
      }
      console.log("bandejaId",this.bandejaId);
      console.log("secuenciaSuministro",this.secuenciaSuministro);
      console.log("nro_suministro",this.nro_sumininstro);
      console.log("codigoOficina",this.codigoOficina);
      console.log("parentesco",this.parentesco);
      console.log("nombres",this.nombres);
      console.log("apellidos",this.apellidos);
      console.log("tipo_documento",this.tipo_documento);
      console.log("desc_tipo_docu",this.desc_tipo_docu);
      console.log("nro_documento",this.nro_documento);
      console.log("telefono",this.telefono);
      console.log("celular",this.celular);
      console.log("correo",this.correo);
      /* jpuyen 30/11/2021 Inicio*/
      if (this.bandejaId == null || this.bandejaId == undefined){
        this.flagEnableParent = false;
      }else{
        this.flagEnableParent = true;
      }
      /*
      if (this.parentesco == "FW001") {
        this.flagEnableParent = true;
      } else {
        this.flagEnableParent = false;
      }*/
      /* Jpuyen 30/11/2021 fin*/

      this.correo = this.correo.replace(/\s/g, "");

      this.datos = new FormGroup({
        parentesco: new FormControl({value: this.parentesco, disabled: this.flagEnableParent}, Validators.required),
        //telefono: new FormControl({value: this.telefono, disabled: false}, Validators.required),
        telefono: new FormControl({value: this.telefono, disabled: false}),
        celular: new FormControl({value: this.celular, disabled: false}, Validators.required),
        correo: new FormControl({value: this.correo, disabled: false}, Validators.required),
        codigo1: new FormControl({value: '', disabled: false}, Validators.required),
        codigo2: new FormControl({value: '', disabled: false}, Validators.required),
        codigo3: new FormControl({value: '', disabled: false}, Validators.required),
        codigo4: new FormControl({value: '', disabled: false}, Validators.required)
      });

      this.datos.value.parentesco = this.parentesco;
      console.log("this.dataos.value.parentesco",this.datos.value.parentesco);

      this.loadBandejaDocs();

    }

    get f() {
      return this.datos.controls;
    }

    getDescTipoDoc(tipoDoc: string) {
      let retorned: string;
      if (tipoDoc === "TD001") {
        retorned = "DNI";
      } else {
        if (tipoDoc === "TD002") {
          retorned = "RUC";
        } else {
          if (tipoDoc === "TD003") {
            retorned = "Carnet de extranjeria";
          } else {
            if (tipoDoc === "TD004") {
              retorned = "Sin informacion";
            } else {
              if (tipoDoc === "TD005") {
                retorned = "Pasaporte";
              } else {
                if (tipoDoc === "TD006") {
                  retorned = "Carnet de identidad";
                } else {
                  if (tipoDoc === "TD007") {
                    retorned = "Carnet de Fuerzas Policiales";
                  } else {
                    if (tipoDoc === "TD008") {
                      retorned = "Carnet de Fuerzas Armadas";
                    } else {
                      if (tipoDoc === "TD009") {
                        retorned = "Partida Registral";
                      } else {
                        if (tipoDoc === "TD010") {
                          retorned = "Cédula Diplomática de Identidad";
                        } else {
                          if (tipoDoc === "TD011") {
                            retorned = "Doc.Trib.No.Dom.Sin.RUC";
                          } else {
                            retorned = "";
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return retorned;
    }

    ngOnInit() {
      if (
        this.globals.tip_docum === "" ||
        this.globals.suministro === "" ||
        this.globals.num_docum === ""
      ) {
        this.toastr.warning(
          "Se perdió la conexión, vuelva a ingresar para continuar. Datos del solicitante no encontrados",
          "Atención", {
          timeOut: 5000,
        });
        this.router.navigate(["/iniciar-sesion"]);
        return;
      }

      if (this.data == null || this.data == undefined || this.data == 'NaN') {
        this.toastr.warning(
          "Se perdió la conexión, vuelva a ingresar para continuar. Datos del solicitante no encontrados",
          "Atención", {
            timeOut: 5000,

        });
        this.router.navigate(["/iniciar-sesion"]);
        return;
      }

      if (this.globals.app_title === "WT001") {
        this.botonIr = "Ir a Financiamiento";
      } else {
        this.botonIr = "Ir a Fraccionamiento";
      }

      this.loadLimitFile();
      //this.loadValidaFinanciamiento();

    }

    loadLimitFile() {
      // Obtener limite capacidad de archivos
      let strLimitFilePDF: string;
      const bodyPDF = {
        clase: "FW_DIRECTORIO_TRABAJO",
        modulo: "ACUERDOS_WEB",
        categoria: "TAMANIO_ARCHIVO_MegaBytes_PDF"
      };
      this.financiamientoApiService.getParametrosGc(bodyPDF).subscribe((response) => {
        strLimitFilePDF = response.resultado.find((x) => x.categoria == "TAMANIO_ARCHIVO_MegaBytes_PDF").valor;
        console.log("strLimitFilePDF",strLimitFilePDF);
        this.limitFile_pdf = parseInt(strLimitFilePDF);

        //Cargar url de fraccionamiento
        this.consultaUrlFraccionamiento();
      });


      let strLimitFileJPG: string;
      const body = {
        clase: "FW_DIRECTORIO_TRABAJO",
        modulo: "ACUERDOS_WEB",
        categoria: "TAMANIO_ARCHIVO_MegaBytes_JPG"
      };
      this.financiamientoApiService.getParametrosGc(body).subscribe((response) => {
        strLimitFileJPG = response.resultado.find((x) => x.categoria == "TAMANIO_ARCHIVO_MegaBytes_JPG").valor;
        console.log("strLimitFileJPG",strLimitFileJPG);
        this.limitFile_jpg = parseInt(strLimitFileJPG);

        //Cargar url de fraccionamiento
        this.consultaUrlFraccionamiento();
      });


      // Obtener remitente del correo de validacion
    const bodyCorreoRemitente = {
      clase: "FW_NOTIFICACION_VALIDA_CORREO",
      modulo: "ACUERDOS_WEB",
      categoria: "REMITENTE"
    };
    this.financiamientoApiService.getParametrosGc(bodyCorreoRemitente).subscribe((response) => {
      this.correoValiRemitente = response.resultado.find((x) => x.categoria == "REMITENTE").valor;
      console.log('this.correoValiRemitente: '+this.correoValiRemitente);
    });

    // Obtener asunto del correo de validacion
    const bodyCorreoAsunto = {
      clase: "FW_NOTIFICACION_VALIDA_CORREO",
      modulo: "ACUERDOS_WEB",
      categoria: "ASUNTO"
    };
    this.financiamientoApiService.getParametrosGc(bodyCorreoAsunto).subscribe((response) => {
      this.correoValiAsunto = response.resultado.find((x) => x.categoria == "ASUNTO").valor;
      console.log('this.correoValiAsunto: '+this.correoValiAsunto);
    });

    // Obtener parrafo01 del correo de validacion
    const bodyCorreoParrafo01 = {
      clase: "FW_NOTIFICACION_VALIDA_CORREO",
      modulo: "ACUERDOS_WEB",
      categoria: "PARRAFO_01"
    };
    this.financiamientoApiService.getParametrosGc(bodyCorreoParrafo01).subscribe((response) => {
      this.correoValiParrafo01 = response.resultado.find((x) => x.categoria == "PARRAFO_01").valor;
      console.log('this.correoValiParrafo01: '+this.correoValiParrafo01);
    });

    // Obtener parrafo02 del correo de validacion
    const bodyCorreoParrafo02 = {
      clase: "FW_NOTIFICACION_VALIDA_CORREO",
      modulo: "ACUERDOS_WEB",
      categoria: "PARRAFO_02"
    };
    this.financiamientoApiService.getParametrosGc(bodyCorreoParrafo02).subscribe((response) => {
      this.correoValiParrafo02 = response.resultado.find((x) => x.categoria == "PARRAFO_02").valor;
      console.log('this.correoValiParrafo02: '+this.correoValiParrafo02);
    });


    }

    consultaUrlFraccionamiento() {
      //LRIOS INICIO
      //leer parametro y guardarlo en global
      const body = {
        clase: "FR_DIRECTORIO_TRABAJO",
        modulo: "FRACCIONAMIENTO_WEB",
        categoria: "URL_WEB"
      };
      this.financiamientoApiService.getParametrosGc(body).subscribe((response) => {
        this.globals.url_navegacion = response.resultado.find((x) => x.categoria == "URL_WEB").valor;
        console.log("urlWeb",this.globals.url_navegacion);
        localStorage.setItem("data_url", this.globals.url_navegacion);
      });
      //LRIOS FIN
    }

    buscarDocs() {
      let codParentesco: string;
      this.dataSource = [];
      console.log("parentescoCod",this.parentesco);
      console.log("this.datos.value.parentesco",this.datos.value.parentesco);
      if (this.flagEnableParent) {
        codParentesco = this.parentesco;
      } else {
        codParentesco = this.datos.value.parentesco;
      }
      console.log("codParentesco",codParentesco);

      const body = {
        parentescoCod: codParentesco
      };

      this.financiamientoApiService
        .getDocsParentesco(body)
        .toPromise()
        .then((response) => {
          this.filesMap.clear();
          console.log("response-buscarDocs",response);
          this.dataSource = response.resultado;
      });
    }

    mostrarDialogo(event: any): void {
      this.dialog
        .open(DialogoConfirmacionComponent, {
          data: `¿Desea eliminar el documento seleccionado?`
        })
        .afterClosed()
        .subscribe((confirmado: Boolean) => {
          if (confirmado) {
            this.filesMap.delete(event.id);
            event.docAdjunto = "";
            event.tieneDocumento = false;
            //this.returnDialog = true;
            this.toastr.success("Documento Eliminado satisfactoriamente.", "Confirmación", {closeButton: true,})
          }
      });
    }

    disableDocumentos() {
      if (this.dataSource) {
        this.dataSource.forEach(function (value) {
          console.log("disable",value);
          value.tieneDocumento = true;    //if working
          value.disabledAdjuntar = true;  //no work
          value.disabledEliminar = true;  //no work
        });
        this.disabledActions = true;
      }
    }

    enabledDocumentos() {
      console.log("enabled documentos begin");
      this.dataSource.forEach(function (value) {
        console.log("enable",value);
        value.tieneDocumento = false;    //if working
        value.disabledAdjuntar = false;  //no work
        value.disabledEliminar = false;  //no work
      });
      this.disabledActions = false;
      console.log("enabled documentos end");
    }

    async verEvent(event: any) {
      if (this.existeBandeja && event.estadoDocumento === "DC002") {
        console.log("id",event.id);
        console.log("docAdjunto",event.docAdjunto);

        const body = {
          nombreAchivo: event.docAdjunto
        };

        this.financiamientoApiService
          .getDescargarArchivo(body)
          .toPromise()
          .then((response) => {

            if (response.resultado.flag) {

              let nombreArchivo    = response.resultado.fileName;
              let extensionArchivo = nombreArchivo.split(".").pop();

              if (extensionArchivo && extensionArchivo === 'pdf') {

                //pdf
                const dialogRef = this.dialog.open(VisorDocumentosComponent, {
                  data: {
                    src: `data:application/pdf;base64,${response.resultado.fileBase64}`,
                    nombre: response.resultado.fileName,
                    tipo: 'application/pdf',
                  },
                });

              } else {

                //img
                const dialogRef = this.dialog.open(VisorDocumentosComponent, {
                  data: {
                    src: `data:image/jpeg;base64,${response.resultado.fileBase64}`,
                    nombre: response.resultado.fileName,
                    tipo: 'image/jpeg',
                  },
                });

              }

            } else {
              this.toastr.error("No se encontró el archivo adjunto en la carpeta compartida.", "Atención", {
                closeButton: true,
              });
            }
        }).catch(error=>{
          console.log(error);
        });

      } else {

        let file = this.filesMap.get(event.id).file;
        const dialogRef = this.dialog.open(VisorDocumentosComponent, {
          data: {
            src: await this.getBase64(file),
            nombre: file.name,
            tipo: file.type,
          },
        });

      }
    }

    async getBase64(file: any): Promise<any> {
      return await new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = (error) => {
          reject(error);
        };
      });
    }

    cambiarNombreArchivo(filename: string) {
      let tipoExtension: string;
      let nroSuministro: string = "0";
      let tipDocumento: string;
      let nroDocumento: string;

      if (filename && filename.length > 0) {
        tipoExtension = filename.split(".").pop();
        nroSuministro = this.globals.suministro.toString();
        tipDocumento  = this.globals.tip_docum.toString()
        nroDocumento  = this.globals.num_docum.toString();

        let j = 0;
        this.dataSource.forEach(function (value) {
          let nombreArchivo: string = "";
          const tipoDocuDNI = "TD001";
          if (tipoDocuDNI == tipDocumento) {
            nombreArchivo = nroSuministro+"_"+(j+1)+"."+tipoExtension;
          } else {
            nombreArchivo = nroSuministro+"_"+nroDocumento+(j+1)+"."+tipoExtension;
          }
          value.docAdjunto = nombreArchivo;
          j++;
        });
      }
    }

    adjuntarEvent(event: any) {

    let flagExcedido: boolean = false;
    let msjeExcedido: string = '';
    let factor: number = 1048576;
    let capacidad_PDF:number = factor * this.limitFile_pdf;
    let capacidad_JPG:number = factor * this.limitFile_jpg;

    console.log("capacidad_PDF",capacidad_PDF);
    console.log("capacidad_JPG",capacidad_JPG);

      console.log('NUEVO event.file.name.split(".")[0]: '+event.file.name.split(".")[1])

      let tipoExt = event.file.type === 'image/jpeg' ? 'jpg' : 'pdf';

      console.log('event.file.size: '+event.file.size);

      let sizeFile:number = event.file.size;


      if(tipoExt==='pdf'){

        if (capacidad_PDF < sizeFile) {
          flagExcedido = true;
          msjeExcedido="El documento adjunto ha excedido el límite máximo permitido para PDF: "+this.limitFile_pdf+" MB";
        } else {
          flagExcedido = false;
        }

      }else{

        if (capacidad_JPG < sizeFile) {
          flagExcedido = true;
          msjeExcedido="El documento adjunto ha excedido el límite máximo permitido para JPG: "+this.limitFile_jpg+" MB";
        } else {
          flagExcedido = false;
        }


      }

      if (flagExcedido) {
        this.toastr.warning(
          msjeExcedido,"Atención",
          { closeButton: true }
        );
      }else{

          this.filesMap.set(event.item.id, { file: event.file, item: event.item });
          let item = this.dataSource.find((x) => x.id === event.item.id);
          console.log("item",item);
          if (item) {
            item.docAdjunto = this.getFileChanged(item.id, event.file.name);
            item.tieneDocumento = true;
          }
      }
    }

    eliminarEvent(event: any) {
      //invocar al dialog...
      this.mostrarDialogo(event);
      //console.log("returnDialog",this.returnDialog);
      //if (this.returnDialog) {

        /*
        this.filesMap.delete(event.id);
        event.docAdjunto = "";
        event.tieneDocumento = false;
        */

      //}
    }

    getFileChanged(j: number, filename: string) {
      let returned: string = "";

      let tipoExtension: string;
      let nroSuministro: string = "0";
      let nroDocumento: string;

      let nombreArchivo: string = "";
      const tipoDocuDNI = "TD001";

      tipoExtension = filename.split(".").pop();
      nroSuministro = this.globals.suministro.toString();
      nroDocumento  = this.globals.num_docum.toString();

      console.log("tipoExtension",tipoExtension);
      console.log("nroSuministro",nroSuministro);
      console.log("nroDocumento",nroDocumento);

      returned = nroSuministro+"_"+nroDocumento+"_"+(j)+"."+tipoExtension;
      return returned;
    }

    loadBandejaDocs() {
      //PRIMERO CARGAMOS PARENTESCOS
      this.financiamientoApiService.getParentescos()
        .toPromise()
        .then((response: any) => {
          console.log(response);
          this.parentescos = this.parentescos.concat(response.resultado);
          //SEGUNDO CARGAMOS BANDEJA DOCUMENTOS
          const body = {
            numSuministro: this.nro_sumininstro,
            tipDocumento: this.tipo_documento,
            numDocumento: this.nro_documento,
            tipSolicitante: this.parentesco
          };
          console.log("body-docs", body);

          if (this.globals.estado_tramite === 'TR007' || this.globals.estado_tramite === 'TR008') {
            this.bandejaId = 0;
            this.buscarDocs();
            return;
          }

          this.financiamientoApiService.getBandejaDocs(body).toPromise().then(
            (response2: any) => {
              this.existeBandeja = response2.resultado.existe;
              this.bandejaId = response2.resultado.bandejaId;
              this.estadoTramite = response2.resultado.estadoTramite;
              console.log("resultado", response2.resultado);
              console.log("existeBandeja", this.existeBandeja);
              console.log("bandejaId", this.bandejaId);
              console.log("estadoTramite", this.estadoTramite);
              console.log("documentos", response2.resultado.documentos);
              this.dataSource = response2.resultado.documentos;
              console.log("dataSource", this.dataSource);
              if (this.existeBandeja) {
                this.cargarGrilla();
              } else {
                this.buscarDocs();
              }
            }
          ).catch(error2=>{
            console.log("error", error2);
          });
      }).catch((error: any) => {
          console.log(error);
      });
    }

    cargarGrilla() {
      //recargar botones en la grilla
      let flagActions: boolean = false;
      if (this.dataSource) {
        this.dataSource.forEach(function (value) {
          console.log("ds-value",value);
          value.tieneDocumento = true;
          if (value.estadoDocumento === "DC002") {
            flagActions = true;
          } else {
            flagActions = false;
          }
        });


        //REVISAR LOGICA
        if (flagActions) {
          this.disabledActions = true;
          this.flagBotonDocs = true;
        } else {
          this.disabledActions = false;
          this.flagBotonDocs = false;
        }

      }
      //this.disabledActions = false;
    }

    /*ngOnDestroy(): void {
      this.mobileQuery.removeListener(this._mobileQueryListener);
    }*/

    //Focos para los codigos 1-4
    processKeyUp(e, el) {
      el.focus();
    }

    validacionCorreoFinal() {
      this.codigoValidacionWeb =
        this.datos.value.codigo1.toString() +
        this.datos.value.codigo2.toString() +
        this.datos.value.codigo3.toString() +
        this.datos.value.codigo4.toString();

      this.flagCodigovalidacion = false;
      if (this.datos.value.correo.toString() == this.correoTemporal) {
        if (this.codigoValidacionWeb == this.codigoValidacion) {
          this.flagCodigovalidacion = true;
          this.flagEnviar = true;
          this.flagBoton = false;
          this.toggle = false;
          this.toastr.success("Validación de correo satisfactoria.", "Atención", {
            closeButton: true,
          });
        } else {
          this.flagEnviar = false;
          this.flagBoton = true;
          this.toggle = true;
          this.toastr.warning("Código de verificación inválido", "Atención", {
            closeButton: true,
          });
          return;
        }
      } else {
        this.flagCodigovalidacion = false;
        this.datos["controls"]["codigo1"].setValue("");
        this.datos["controls"]["codigo2"].setValue("");
        this.datos["controls"]["codigo3"].setValue("");
        this.datos["controls"]["codigo4"].setValue("");
        this.toggle = true;
        this.toastr.warning(
          "El Correo a cambiado debe Validar nuevamente. ",
          "Atención",
          { closeButton: true }
        );
        return;
      }

      //BORRAR BEGIN
      //this.flagCodigovalidacion = true;
      //this.flagEnviar = true;
      //this.flagBoton = false;
      //this.toggle = false;
      //BORRAR END
    }

    opcionSi(){
      this.datoSolCorrecto = 1;
      this.flagBotonFina = true;
      this.flagBotonDato = false;
    }

    opcionNo(){
      this.datoSolCorrecto = 2;
      this.flagBotonFina = false;
      this.flagBotonDato = true;
    }

    validaCorreo(){
      if(this.mailValido){
        (<any>Object).values(this.datos.controls).forEach((control) => {
          control.markAsTouched();
        });

        this.correoTemporal = this.datos.value.correo.toString();
        console.log("temporal: ", this.correoTemporal);
        let remitente =
          this.nombres +
          ", " +
          this.apellidos;
        console.log("remitente",remitente);

        if (remitente != "" && this.datos.value.correo != "") {
          const body = {
            usuario: remitente,
            //usuario: "",
            email: this.datos.value.correo.toString(),
            sistema: "FINANCIAMIENTO WEB",
            asunto: this.correoValiAsunto,
            parrafo_01: this.correoValiParrafo01,
            parrafo_02: this.correoValiParrafo02,
            remitente: this.correoValiRemitente,
            rutaLogo: "https://webapp16.sedapal.com.pe/OficinaComercialVirtual/images/logo-sedapal.png"

          };

          //Obtener Codigo de verificacion
          this.codigoValidacion = "";
          this.supplyService.validarCorreo(body).toPromise().then((response) => {
            this.codigoValidacion = response.bRESP.data.codigoVerificacion;
            if (this.codigoValidacion.length) {
              this.toastr.info(
                "Se le envió codigo de verificación de cuatro dígitos a su correo.",
                "Información",
                { closeButton: true }
              );
            } else {
              this.toastr.warning(
                "Verifique con su administrador si la url del servicio esta funcionado!",
                "Atención",
                { closeButton: true }
              );
            }
          }).catch(errorCorreo=>{
            console.error("errorCorreo",errorCorreo);
            this.toastr.warning(
              "No se pudo realizar el envío de la notificación por correo.",
              "Advertencia",
              {
                closeButton: true,
              }
            );
          });
        } else {
          this.toastr.warning(
            "Apellidos, Nombres, Celular del solicitante y Correo Electrónico no pueden ser vacíos",
            "Atención",
            { closeButton: true }
          );
          return;
        }
      }
    }

    stripCorreo(){
      this.mailValido=false;
      let email = this.datos.value.correo;
      //let EMAIL_REGEX = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
      let EMAIL_REGEX = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

      if (email.match(EMAIL_REGEX)) {
        this.mailValido = true;
        this.flagCodigovalidacion= false;
        this.datos['controls']['codigo1'].setValue("");
        this.datos['controls']['codigo2'].setValue("");
        this.datos['controls']['codigo3'].setValue("");
        this.datos['controls']['codigo4'].setValue("");
      }
      if(!this.mailValido){
        this.blockUI.stop();
        this.mailValido = false;
        this.toastr.warning('Formato de Correo inválido', 'Atención', {closeButton: true});
        return;
      }
    }

    stripCelular() {
      let celularValido = false;
      let celular = this.datos.value.celular;
      let CELULAR_REGEX = /^[0-9]{9}$/;
      celular = String(celular);

      if (celular.match(CELULAR_REGEX)) {
        celularValido = true;
      }
      if (!celularValido) {
        this.blockUI.stop();
        this.toastr.warning('Celular debe tener 9 digitos', 'Atención', {closeButton: true});
        return;
      } else {
        let strCelular = celular.toString();
        let primerNumero = strCelular.substring(0,1);

        if (primerNumero != '9') {
          this.blockUI.stop();
          this.toastr.warning('Celular debe empezar con el digito 9', 'Atención', {closeButton: true});
          return;
        }
      }
    }

    stripText(control: FormControl) {
      control.setValue(control.value.replace(/[^0-9]/g, ''));
    }


    validForm() {
      (<any>Object).values(this.datos.controls).forEach((control) => {
        control.markAsTouched();
      });

      if (this.datos.invalid) {
        this.toastr.warning(
          "Apellidos, Nombres, Celular del solicitante y Correo Electrónico no pueden ser vacíos",
          "Atención",
          { closeButton: true }
        );
        return false;
      }

      // Validar documentos
      /*
      if (this.dataSource) {
        for (let index = 0; index < this.dataSource.length; index++) {
          if (
            this.dataSource[index].tieneDocumento === null ||
            this.dataSource[index].tieneDocumento === undefined
          ) {
            this.toastr.warning(
              "Adjunte todos los documentos solicitados",
              "Atención",
              { closeButton: true }
            );
            return false;
          }
        }
      } else {
        this.toastr.warning(
          "Adjunte todos los documentos solicitados",
          "Atención",
          { closeButton: true }
        );
        return false;

        console.log("datasource",this.dataSource);
      }
      */

      if (this.dataSource) {
        for (let index = 0; index < this.dataSource.length; index++) {
          if (this.dataSource[index].docAdjunto === null || this.dataSource[index].docAdjunto === undefined) {
            this.toastr.warning(
              "Adjunte todos los documentos solicitados",
              "Atención",
              { closeButton: true }
            );
            return false;
          } else {
            let strDocAdjunto = this.dataSource[index].docAdjunto;
            strDocAdjunto = strDocAdjunto.replace(/\s/g, "");
            if (strDocAdjunto.length == 0) {
              this.toastr.warning(
              "Adjunte todos los documentos solicitados",
              "Atención",
              { closeButton: true }
              );
              return false;
            }
          }
        }
	    }
/*
      // Validar que no excede la capacidad limite de los archivos
      let flagExcedido: boolean = false;
      let factor: number = 1048576;
      //let capacidad:number = 10485760;
      let capacidad:number = factor * this.limitFile;
      console.log("capacidad",capacidad);

      this.sizeFile = 0;
      this.filesMap.forEach((value: any) => {
        //this.sizeFile = this.sizeFile + value.file.size;
        this.sizeFile = value.file.size;
        if (capacidad < this.sizeFile) {
          flagExcedido = true;
        }
      });
      console.log("size", this.sizeFile);
      console.log("flagExcedido", flagExcedido);

      if (flagExcedido) {
        this.toastr.warning(
          //"Documentos adjuntos excedieron el limite máximo!",
          "Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
          "Atención",
          { closeButton: true }
        );
        return false;
      }*/

      return true;
    }

    getFileName(j: number, file: any, formValue: any) {
      let returned: string = '';
      let nroSuministro = formValue.suministro;
      let nroDocumento = formValue.numDocumento;
      let tipoExt = file.type === 'image/jpeg' ? 'jpg' : 'pdf';

      returned = nroSuministro + "_" + nroDocumento + "_" + (j + 1) + "." + tipoExt;
      return returned;
    }

    submitActualizarDatos() {
      if (this.validForm()) {

        console.log("controls-telefono",this.datos["controls"]["telefono"].value);
        console.log("controls-celular",this.datos["controls"]["celular"].value);
        console.log("controls-correo",this.datos["controls"]["correo"].value);

        this.dataInput = {
          suministro: this.nro_sumininstro,
          secuenciaSuministro: this.secuenciaSuministro,
          codigoOficina: this.codigoOficina,
          codigoParentesco: this.parentesco,
          paterno: this.paterno,
          materno: this.materno,
          nombres: this.nombres,
          tipoDocumento: this.tipo_documento,
          numDocumento: this.nro_documento,
          telefono: this.datos["controls"]["telefono"].value,
          celular: this.datos["controls"]["celular"].value,
          correo: this.datos["controls"]["correo"].value,
          estadoSolicitud: "SO002",
          motiEstadoSolic: "MS002"
        };
        console.log("dataInput",this.dataInput);

        //let formValue = this.datos.getRawValue();
        this.data = JSON.parse (localStorage.getItem ('dataRegistro'));
        console.log("this.dataRegistro",this.data);

        //let secuenciaSuministro: any = this.data.secuSuministro;
        //let codigoOficina: any = this.data.codOficina;
        let docAdjuntos: any = [];
        let j = 0;
        this.filesMap.forEach((value: any, key: any) => {
          docAdjuntos.push({
            idBandeja: 0,
            tipoDocArchivo: value.item.tipo,
            nombreArchivo: this.getFileName(j, value.file, this.dataInput),
            estadoDocumento: "DC001",
            motivoRechazo: ' ',
          });
          j++;
        });
        console.log("docAdjuntos", docAdjuntos);

        let formData = new FormData();
        formData.append("suministro", this.dataInput.suministro);
        formData.append("secuenciaSuministro", this.dataInput.secuenciaSuministro);
        formData.append("codigoOficina", this.dataInput.codigoOficina);
        formData.append("codigoParentesco", this.dataInput.codigoParentesco);
        formData.append("paterno", this.dataInput.paterno);
        formData.append("materno", this.dataInput.materno);
        formData.append("nombres", this.dataInput.nombres);
        formData.append("tipoDocumento", this.dataInput.tipoDocumento);
        formData.append("numDocumento", this.dataInput.numDocumento);
        formData.append("telefono", this.dataInput.telefono);
        formData.append("celular",this.dataInput.celular);
        formData.append("correo", this.dataInput.correo);
        formData.append("estadoSolicitud", this.dataInput.estadoSolicitud);
        formData.append("motiEstadoSolic", this.dataInput.motiEstadoSolic);
        formData.append("docAdjuntos", JSON.stringify(docAdjuntos));

        this.filesMap.forEach((value: any) => {
          formData.append("document", value.file, value.file.name);
        });
        this.financiamientoApiService
        .registrarSolicitante(formData)
        .toPromise()
        .then((response: any) => {
          console.log(response);
          console.log("response.estado", response.estado);
          if (response.estado === "OK") {
              let data: any = {
                idBandeja: response.resultado.idBandeja,
                usuario: response.resultado.usuario,
                fechaActual: response.resultado.fechaActual,
                programa: response.resultado.programa,
                fechaUltimoMovimiento: response.resultado.fechaUltimoMovimiento,
                fechaAlta: response.resultado.fechaAlta,
                suministro: response.resultado.suministro,
                secuenciaSuministro: response.resultado.secuenciaSuministro,
                numeroAcuerdo: response.resultado.numeroAcuerdo,
                codigoOficina: response.resultado.codigoOficina,
                fechaSolicitud: response.resultado.fechaSolicitud,
                tipoSolicitante: response.resultado.tipoSolicitante,
                paternoSolicitante: response.resultado.paternoSolicitante,
                maternoSolicitante: response.resultado.maternoSolicitante,
                nombresSolicitante: response.resultado.nombresSolicitante,
                tipoDocumento: response.resultado.tipoDocumento,
                numDocumento: response.resultado.numDocumento,
                telefonoSolicitante: response.resultado.telefonoSolicitante,
                celularSolicitante: response.resultado.celularSolicitante,
                correoSolicitante: response.resultado.correoSolicitante,
                numArchivo: response.resultado.numArchivo,
                deudaTotal: response.resultado.deudaTotal,
                numCuota: response.resultado.numCuota,
                montoCuota: response.resultado.montoCuota,
                numRecibo: response.resultado.numRecibo,
                estadoSolicitante: response.resultado.estadoSolicitante,
                motivoEstadoSolicitante: response.resultado.motivoEstadoSolicitante,
                estadoTramite: response.resultado.estadoTramite,
                tipoTramite: response.resultado.tipoTramite,
                indicadorDescarga: response.resultado.indicadorDescarga,
                indicadorCorreo: response.resultado.indicadorCorreo
              };
              console.log("data", data);

              localStorage.setItem("dataSolicitante", JSON.stringify(data));

              this.globals.admin_msg_shared = 2;
              this.flag2 = true;
              this.flag = false;
              this.globals.tipo_form_solicitante = 2;
              this.router.navigate(["/mensaje-registro"]);
            } else {
              this.flag2 = false;
              this.flag = false;
              //this.toastr.error("No se logró realizar la actualización de datos del solicitante", "Error", {
              //  closeButton: true,
              //});
              this.toastr.error(response.resultado.mensaje, "Error", {
                closeButton: true,
              });
            }
          }).catch(errorCorreo=>{
            console.error("errorCorreo",errorCorreo);
            this.toastr.warning(
              "No se logró actualizar la bandeja. Inténtelo nuevamente.",
              "Advertencia",
              {
                closeButton: true,
              }
            );
          });

      }
    }

    submitFinanciamiento() {
      if (this.validForm()) {
        if (this.globals.estado_tramite === 'TR007' || this.globals.estado_tramite === 'TR008') {
          this.bandejaId = 0;
          //blanquear
        }
        console.log("bandejaId-fina",this.bandejaId);

        this.dataInput = {
          bandejaId: this.bandejaId,
          suministro: this.nro_sumininstro,
          tipoDocumento: this.tipo_documento,
          numDocumento: this.nro_documento,
          secuenciaSuministro: this.secuenciaSuministro,
          codigoOficina: this.codigoOficina,
          nombres: this.nombres,
          apellidos:this.apellidos,
          descTipoDocu: this.desc_tipo_docu,
          tipoSolicitante: this.parentesco
        };
        console.log("dataInput",this.dataInput);
        console.log("this.filesMap",this.filesMap);
        console.log("this.filesMap.size",this.filesMap.size);

        console.log("PASO 1: Preparar objeto documentos...");
        let docAdjuntos: any = [];
        let j = 0;

        this.filesMap.forEach((value: any, key: any) => {
          console.log("j: ", j);
          docAdjuntos.push({
            idBandeja: 0,
            tipoDocArchivo: value.item.tipo,
            nombreArchivo: this.getFileName(j, value.file, this.dataInput),
            estadoDocumento: "DC001",
            motivoRechazo: " ",
          });
          j++;
        });
        console.log("docAdjuntos",docAdjuntos);

        console.log("PASO 2...");
        let formData: FormData = new FormData();
        formData.append("suministro", this.dataInput.suministro);
        formData.append("numDocumento", this.dataInput.numDocumento);
        formData.append("tipoDocumento",this.tipo_documento);
        //formData.append("docAdjuntos", JSON.stringify(docAdjuntos));

        this.filesMap.forEach((value: any) => {
          formData.append("document", value.file, value.file.name);
        });

        let flagDocs: boolean;
        this.financiamientoApiService
          .registrarArchivosTemporal(formData)
          .toPromise()
          .then((response: any) => {
            console.log(response);
            console.log("response.estado", response.estado);
            if (response.estado === "OK") {
              flagDocs = response.resultado;
            } else {
              flagDocs = false;
              this.toastr.error("No se logró realizar el registro de archivos temporales", "Error", {
                closeButton: true,
              });
            }

            console.log("PASO 3...");
            console.log("controls-telefono",this.datos["controls"]["telefono"].value);
            console.log("controls-celular",this.datos["controls"]["celular"].value);
            console.log("controls-correo",this.datos["controls"]["correo"].value);

            console.log("dataInput.bandejaId",this.dataInput.bandejaId);

            let dataFinanciento: any = {
              bandejaId: this.dataInput.bandejaId,
              suministro: this.dataInput.suministro,
              secuenciaSuministro: this.dataInput.secuenciaSuministro,
              codigoOficina: this.dataInput.codigoOficina,
              nombres: this.dataInput.nombres,
              apellidos:this.dataInput.apellidos,
              descTipoDocu: this.dataInput.descTipoDocu,
              tipoDocumento: this.dataInput.tipoDocumento,
              numeroDocumento: this.dataInput.numDocumento,
              tipoSolicitante: this.dataInput.tipoSolicitante,
              telefono: this.datos["controls"]["telefono"].value,
              celular: this.datos["controls"]["celular"].value,
              correo: this.datos["controls"]["correo"].value,
              docAdjuntos: docAdjuntos,
              flagDocs: flagDocs
            };

            console.log("integracion: ",dataFinanciento);

            if (this.globals.app_title === "WT001") {
              localStorage.setItem("finacDeuda", JSON.stringify(dataFinanciento));
              this.router.navigate(["/financiamiento-deuda"]);
            } else {
              this.data = JSON.parse (localStorage.getItem ('data'));
              this.router.navigate(["beneficiario"], { queryParams: this.data });
            }
          }).catch(errorCorreo=>{
            console.error("errorCorreo",errorCorreo);
            this.toastr.warning(
              "No se ha podido consultar la información para el financiamiento. Inténtelo nuevamente.",
              "Advertencia",
              {
                closeButton: true,
              }
            );
          });
      }
    }
  }
